import { render, staticRenderFns } from "./Cheques.vue?vue&type=template&id=18f6d845&"
import script from "./Cheques.vue?vue&type=script&lang=js&"
export * from "./Cheques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports